var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "switch_wrap" },
    [
      _vm.reg([
        "/switch/test/preview",
        "/switch/test/stupreview",
        "/switch/test/testPaper",
        "/switch/examination/detailsPage",
        "/switch/test/successNew",
        "/switch/test/success"
      ])
        ? _c("Header", { attrs: { routerarr: _vm.routerArr } })
        : _vm._e(),
      _vm._v(" "),
      _c("main", [_c("router-view")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41bba528", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41bba528","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/switchpage.vue
// module id = null
// module chunks = 